import Vue from 'vue'
import VueRouter from 'vue-router'
Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'home',
    component: () => import('../views/Login.vue')
  },
  {
    path: '/login',
    name: 'login',
    component: () => import('../views/Login.vue')
  },
  {
    path: '/configuration',
    name: 'configuration',
    component: () => import('../views/configuration.vue'),
    meta: {
      routerName: {
        en: 'Home',
        sp: 'Hogar',
        po: 'Casa'
      }
    }
  },
  {
    path: '/project',
    name: 'project',
    component: () => import('../views/project/project.vue'),
    children: [
      {
        path: '/infomation',
        name: 'infomation',
        component: () => import('../views/infomation/readonlyInformation.vue'),
        meta: {
          routerName: {
            en: 'Panel logs',
            sp: 'Historico de la central',
            po: 'Logs do painel'
          }
        }
      }, {
        path: '/deviceTable',
        name: 'deviceTable',
        component: () => import('../views/deviceTable/deviceTable.vue'),
        meta: {
          routerName: {
            en: 'Loop devices',
            sp: 'Dispositivos de lazo',
            po: 'Dispositivos de loop'
          }
        }
      }, {
        path: '/delays',
        name: 'delays',
        component: () => import('../views/zoneDelays/zoneDelays.vue'),
        meta: {
          routerName: {
            en: 'Zone SND+FR Delays',
            sp: 'Retardos de zona SND + FR',
            po: 'Atraso SND + FR de zona'
          }
        }
      }, {
        path: '/silenceableGroup',
        name: 'silenceableGroup',
        component: () => import('../views/silenceableGroup/silenceableGroup.vue'),
        meta: {
          routerName: {
            en: 'Silenceable Group',
            sp: 'Grupo silencioso',
            po: 'Grupo Silencioso'
          }
        }
      }, {
        path: '/configureNetwork',
        name: 'configureNetwork',
        component: () => import('../views/configureNetwork/configureNetwork.vue'),
        meta: {
          routerName: {
            en: 'Configure networking information',
            sp: 'Configurar la información de la red',
            po: 'Configurar a informação da rede'
          }
        }
      },, {
        path: '/setIoCard',
        name: 'setIoCard',
        component: () => import('../views/setIoCard/setIoCard.vue'),
        meta: {
          routerName: {
            en: 'Set the IO card',
            sp: 'Configurar la tarjeta io',
            po: 'Configurar o cartão IO'
          }
        }
      }, {
        path: '/schedule',
        name: 'schedule',
        component: () => import('../views/schedule/daynightSchedule.vue'),
        meta: {
          routerName: {
            en: 'Day/night settings',
            sp: 'Configuración día / noche',
            po: 'Configurações de dia / noite'
          }
        }
      }, {
        path: '/programming',
        name: 'programming',
        component: () => import('../views/programming/advancedProgramming.vue'),
        meta: {
          routerName: {
            en: 'Advanced programming',
            sp: 'Programación avanzada',
            po: 'Programação avançada'
          }
        }
      }, {
        path: '/systemSettings',
        name: 'systemSettings',
        component: () => import('../views/systemSetting/systemSettings.vue'),
        meta: {
          routerName: {
            en: 'System settings',
            sp: 'Ajustes del sistema',
            po: 'Configurações do sistema'
          }
        }
      }, {
        path: '/zoneSettings',
        name: 'zoneSettings',
        component: () => import('../views/zoneSetting/zoneSettings.vue'),
        meta: {
          routerName: {
            en: 'Zone settings',
            sp: 'Configuración de zona',
            po: 'Configurações de zona'
          }
        }
      },
      // {
      //   path: '/zoneGroupTable',
      //   name: 'zoneGroupTable',
      //   component: () => import('../views/zoneSetting/zoneGroupTable.vue'),
      //   meta: {
      //     routerName: {
      //       en: 'Zone/Group table',
      //     }
      //   }
      // }
    ]
  },
  {
    path: '/registerSuccess',
    name: 'registerSuccess',
    component: () => import('../views/registerSuccess.vue')
  },
  {
    path: '/resetSuccess',
    name: 'resetSuccess',
    component: () => import('../views/resetPasswordSuccess.vue')
  }
]

const router = new VueRouter({
  routes
})

export default router
